import { JSX, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { registerSW } from 'virtual:pwa-register';

export function UpdateNotification(): JSX.Element {
  const { t } = useTranslation();

  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);

  const updateSWRef = useRef<(reloadPage?: boolean | undefined) => Promise<void>>(null);

  useEffect(() => {
    const updateSW = registerSW({
      onNeedRefresh: () => setIsUpdateAvailable(true),
    });

    updateSWRef.current = updateSW;
  }, []);

  function confirmUpdate() {
    updateSWRef.current?.();
    setIsUpdateAvailable(false);
  }

  function rejectUpdate() {
    setIsUpdateAvailable(false);
  }

  return (
    <div>
      {isUpdateAvailable && (
        <div className="modal modal-open">
          <div className="modal-box">
            <h2 className="text-xl font-bold mb-2">{t('A new update is available!')}</h2>

            <p>{t('Would you like to refresh to get the latest version?')}</p>

            <div className="modal-action">
              <button className="btn btn-primary btn-lg" onClick={confirmUpdate}>
                {t('Yes')}
              </button>
              <button className="btn btn-lg" onClick={rejectUpdate}>
                {t('No')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
